import React from "react";
import { Box } from "@mui/material";
import PriscriptionHeader from "../PriscriptionHeader";
import PatientDetails from "../PatientDetails";
import PriscriptionFooter from "../PriscriptionFooter";
import VerticalPrescriptionTemplateContent from "./VerticalPrescriptionTemplateContent";
import VerticalPrescriptionPatientDetails from "../VerticalPrescriptionPatientDetails";

const VerticalPrescriptionTemplatePDFExport = ({
  opdData,
  selectedSections,
  selectedReportTemplate,
}: {
  opdData: any;
  selectedSections: { [key: string]: boolean };
  selectedReportTemplate: string;
}) => {
  const isVertical21cm = selectedReportTemplate === "Vertical21cm";

  return (
    <div
      className={
        isVertical21cm
          ? "print-container vertical21cm-print"
          : "print-container"
      }
      style={{
        flexGrow: 1,
        width: "100%",
      }}
    >
      <table
        style={{
          pageBreakInside: "avoid",
          width: "100%",
        }}
      >
        <thead>
          <tr>
            <td>
              {selectedSections?.HEADER &&
                opdData?.businessInformation?.headerEnable && (
                  <Box className="header">
                    <PriscriptionHeader
                      headerData={opdData?.businessInformation}
                    />
                  </Box>
                )}
              <Box>
                <VerticalPrescriptionPatientDetails
                  patientData={opdData}
                  isVertical21cm={isVertical21cm}
                   opdContent={opdData}
                />
              </Box>
            </td>
          </tr>
        </thead>
        <tbody
          style={{
            height: "100%",
            verticalAlign: "top",
          }}
        >
          <tr style={{ height: "100%" }}>
            <td>
              <Box className="content">
                <VerticalPrescriptionTemplateContent
                  opdContent={opdData}
                  selectedSections={selectedSections}
                  selectedReportTemplate={selectedReportTemplate}
                />
              </Box>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              <Box className="footer">
                <PriscriptionFooter
                  footerData={opdData}
                  selectedSections={selectedSections}
                />
              </Box>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default VerticalPrescriptionTemplatePDFExport;